import throttle from 'lodash.throttle';

export const mastheadMenu = {
  mounted(el) {
    const siteHeader = document.querySelector('.js-header');
    const target = document.querySelector('.js-site-masthead-scroll-target');

    function checkIfMastheadIsOutsideView() {
      const isTargetOutsideView = window.scrollY > target.offsetHeight + target.offsetTop - target.offsetHeight;
      if (isTargetOutsideView) {
        el.classList.add('is-collapsed');
        siteHeader.classList.remove('is-masthead-active');
      } else {
        el.classList.remove('is-collapsed');
        siteHeader.classList.add('is-masthead-active');
      }
    }

    // on mount
    checkIfMastheadIsOutsideView();

    // on scroll
    window.addEventListener('scroll', throttle(checkIfMastheadIsOutsideView, 250), { passive: true });
  },
};
